import React from 'react';
import { Icon } from '@iconify/react';
import { depotAwaitingValidation } from './depotUtils';

/** Badges type / statut dépôt — styles `depot-*` intentionnels (pas AppStatusBadge). */

export function DepotTypeBadge({ typeDepot }) {
  if (typeDepot === 'document') {
    return (
      <span className="depot-type-badge depot-type-badge--document">
        <Icon icon="mdi:file-document-outline" aria-hidden />
        Document
      </span>
    );
  }
  if (typeDepot === 'notes') {
    return (
      <span className="depot-type-badge depot-type-badge--notes">
        <Icon icon="mdi:notebook-edit-outline" aria-hidden />
        Notes
      </span>
    );
  }
  return (
    <span className="depot-type-badge depot-type-badge--audio">
      <Icon icon="mdi:microphone-outline" aria-hidden />
      Audio
    </span>
  );
}

export function DepotStatusBadge({ depot }) {
  if (depotAwaitingValidation(depot)) {
    return <span className="depot-badge depot-badge--a-valider">À relire</span>;
  }

  if (depot.statut === 'termine') {
    return (
      <span className="depot-badge depot-badge--termine">
        {depot.type_depot === 'document'
          ? 'Classé'
          : depot.type_depot === 'notes'
            ? 'Notes prêtes'
            : 'Compte rendu prêt'}
      </span>
    );
  }

  if (depot.statut === 'erreur') {
    return <span className="depot-badge depot-badge--erreur">Échec</span>;
  }

  return (
    <span className="depot-badge depot-badge--en-cours">
      <span className="depot-badge__dot" aria-hidden />
      {depot.type_depot === 'document'
        ? 'Classement en cours'
        : depot.type_depot === 'notes'
          ? 'Mise en forme en cours'
          : depot.doc_url || depot.bebedc_url
            ? 'Finalisation en cours'
            : 'Transcription en cours'}
    </span>
  );
}
